module.exports = __webpack_public_path__ + "media/images/stock_groups/f1cc-33dace8da4647d18558654a997ebf838.svg";